import { Stack, Flex, Text, VStack, useBreakpointValue } from '@chakra-ui/react';

export default function HeroWithBackgroundImage({ backGroundImage, title, cta }) {
  return (
    <Flex
      backgroundImage={backGroundImage}
      backgroundSize="cover"
      backgroundPosition="center"
      backgroundRepeat="no-repeat"
      borderRadius={10}
      p={10}
      >
      <VStack
        w="full"
        justify="center"
        px={useBreakpointValue({ base: 4, md: 8 })}>
        <Stack align="center" spacing={6}>
          <Text
            p={4}
            w="100%"
            color={'white'}
            fontWeight={700}
            lineHeight={1.2}
            fontSize={useBreakpointValue({ base: '3xl', md: '4xl' })}>
            { title }
          </Text>
          <Stack direction={'row'}>
            { cta }
          </Stack>
        </Stack>
      </VStack>
    </Flex>
  );
}
